import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import "./ArticleListContainer.css";
import ArticleList from "../ArticleList/ArticleList";
import { connect } from "react-redux";
import {
  loadArticlesRequestAction,
  updateArticlesMetaDataRequestAction,
  updateAnArticleMetaAction
} from "../../redux/actions/articleList";

class ArticleListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHighlightSelectingAll: false,
      isFreeSelectingAll: false,
      isAvailableSelectingAll: false
    };

    this.handleAvaiSelectAll = this.handleAvaiSelectAll.bind(this);
    this.handleFreeSelectAll = this.handleFreeSelectAll.bind(this);
    this.handleHighLightSelectAll = this.handleHighLightSelectAll.bind(this);
  }

  componentDidMount() {
    const {
      isPdf,
      issueID,
      loadedIssueID,
      loadedIsPdf,
      loadArticlesRequestAction
    } = this.props;

    if (issueID !== loadedIssueID || loadedIsPdf !== isPdf) {
      loadArticlesRequestAction(issueID, isPdf);
      window.scrollTo(0, 0);
    }
  }

  handleAvaiSelectAll() {
    const newState = !this.state.isAvailableSelectingAll;
    this.setState({
      isAvailableSelectingAll: newState
    });

    const {
      updateArticlesMetaDataRequestAction,
      isPdf,
      issueID,
      articleIDs,
      articlesDict
    } = this.props;

    let metaData = {};

    for (let i = 0; i < articleIDs.length; i++) {
      const article = articlesDict[articleIDs[i]];
      metaData[article.id] = {
        is_available: i === 0 ? true : newState
      };
    }

    updateArticlesMetaDataRequestAction(issueID, isPdf, metaData);
  }

  handleFreeSelectAll() {
    const newState = !this.state.isFreeSelectingAll;
    this.setState({ isFreeSelectingAll: newState });

    const {
      updateArticlesMetaDataRequestAction,
      isPdf,
      issueID,
      articleIDs,
      articlesDict
    } = this.props;

    let metaData = {};

    for (let i = 0; i < articleIDs.length; i++) {
      const article = articlesDict[articleIDs[i]];
      metaData[article.id] = {
        is_free: i === 0 ? true : newState
      };
    }

    updateArticlesMetaDataRequestAction(issueID, isPdf, metaData);
  }

  handleHighLightSelectAll() {
    const newState = !this.state.isHighlightSelectingAll;
    this.setState({
      isHighlightSelectingAll: newState
    });

    const {
      updateArticlesMetaDataRequestAction,
      isPdf,
      issueID,
      articleIDs,
      articlesDict
    } = this.props;

    let metaData = {};

    for (let i = 0; i < articleIDs.length; i++) {
      const article = articlesDict[articleIDs[i]];
      metaData[article.id] = {
        is_highlight: newState
      };
    }

    updateArticlesMetaDataRequestAction(issueID, isPdf, metaData);
  }

  renderSwitch(isLoading, articleIDs, articlesDict) {
    const { isAdmin } = this.props;

    const highlightVariant = this.state.isHighlightSelectingAll
      ? "warning"
      : "outline-warning";
    const freeVariant = this.state.isFreeSelectingAll
      ? "success"
      : "outline-success";
    const avaiVariant = this.state.isAvailableSelectingAll
      ? "primary"
      : "outline-primary";

    if (isAdmin && !isLoading && articleIDs.length > 0) {
      const highlightedArticleIDs = articleIDs.filter(
        anArticleID => articlesDict[anArticleID].is_highlight
      );
      const freeArticleIDs = articleIDs.filter(
        anArticleID => articlesDict[anArticleID].is_free
      );
      const availableArticleIDs = articleIDs.filter(
        anArticleID => articlesDict[anArticleID].is_available
      );

      return (
        <div className="article_list_select_all_container">
          <Button
            className="article_list_select_all_btn"
            variant={highlightVariant}
            onClick={this.handleHighLightSelectAll}
          >
            {`Highlight(${highlightedArticleIDs.length}/${articleIDs.length})`}
          </Button>
          <Button
            className="article_list_select_all_btn"
            variant={freeVariant}
            onClick={this.handleFreeSelectAll}
          >
            {`Free(${freeArticleIDs.length}/${articleIDs.length})`}
          </Button>
          <Button
            className="article_list_select_all_btn"
            variant={avaiVariant}
            onClick={this.handleAvaiSelectAll}
          >
            {`Available(${availableArticleIDs.length}/${articleIDs.length})`}
          </Button>
        </div>
      );
    } else if (!isLoading && articleIDs.length <= 0) {
      return (
        <Button
          block
          size="lg"
          className="issue_page_btns"
          variant="info"
          onClick={this.props.editTocPressed}
        >
          Add TOC
        </Button>
      );
    } else {
      return null;
    }
  }

  render() {
    const {
      issueID,
      loadedIssueID,
      loadedIsPdf,
      errMsg,
      articleIDs,
      articlesDict,
      isPdf,
      isAdmin,
      updateAnArticleMetaAction
    } = this.props;
    const isLoading = issueID !== loadedIssueID || loadedIsPdf !== isPdf;

    return (
      <Container>
        <Row>{this.renderSwitch(isLoading, articleIDs, articlesDict)}</Row>
        <Row>
          <ArticleList
            issueID={issueID}
            isPdf={isPdf}
            isAdmin={isAdmin}
            isLoading={isLoading}
            articleIDs={articleIDs}
            articlesDict={articlesDict}
            errMsg={errMsg}
            updateAnArticleMetaAction={updateAnArticleMetaAction}
          />
        </Row>
        <Row className="bottom_row">
          {!isLoading && <Col>Total {articleIDs.length} article(s)</Col>}
        </Row>
      </Container>
    );
  }
}

const mapState = (state, ownProps) => {
  const { articleList } = state;

  return articleList;
};

const mapDispatch = {
  loadArticlesRequestAction,
  updateArticlesMetaDataRequestAction,
  updateAnArticleMetaAction
};

export default connect(
  mapState,
  mapDispatch
)(ArticleListContainer);
